import React from 'react';
import { Container } from 'react-bootstrap';

export type VideoComponentProps = React.PropsWithChildren<{
  embedLink: string;
}>;

const VideoComponent = ({ embedLink }: VideoComponentProps) => {
  return (
    <Container className={'px-0 text-center'}>
      <iframe
        width={'100%'}
        height={'480'}
        src={embedLink}
        frameBorder={'0'}
        title={'Embed Video'}
      />
    </Container>
  );
};

export default VideoComponent;
